<main class="auth-page">
  <section class="auth-shell" aria-labelledby="reset-title">
    <div class="auth-shell__accent"></div>
    <div class="auth-content">
      <a class="auth-brand" routerLink="/login" aria-label="GarageDigital"
        ><img src="assets/images/GD_Logotipo_UI.png" alt="GarageDigital"
      /></a>
      <div
        class="auth-icon"
        [ngClass]="{
          'auth-icon--success': state === states.SUCCESS,
          'auth-icon--error':
            state === states.INVALID || state === states.ERROR,
          'auth-icon--warning':
            state === states.EXPIRED ||
            state === states.USED ||
            state === states.MISSING,
        }"
      >
        <i
          class="bi"
          [ngClass]="
            state === states.SUCCESS
              ? 'bi-shield-check'
              : state === states.READY || state === states.LOADING
                ? 'bi-shield-lock'
                : 'bi-link-45deg'
          "
        ></i>
      </div>
      <header class="auth-heading">
        <h1 gdClarityUnmask id="reset-title">Creá una nueva contraseña</h1>
        <p *ngIf="state === states.READY || state === states.LOADING">
          Elegí una contraseña segura que no hayas usado anteriormente.
        </p>
        <p *ngIf="state === states.MISSING">
          El enlace no contiene un token de recuperación.
        </p>
        <p *ngIf="state === states.INVALID">
          El enlace de recuperación no es válido.
        </p>
        <p *ngIf="state === states.EXPIRED">
          El enlace venció. Solicitá uno nuevo para continuar.
        </p>
        <p *ngIf="state === states.USED">Este enlace ya fue utilizado.</p>
      </header>
      <form
        *ngIf="state === states.READY || state === states.LOADING"
        class="auth-form"
        [formGroup]="form"
        (ngSubmit)="submit()"
        novalidate
      >
        <div class="auth-field">
          <label for="new-password">Nueva contraseña</label>
          <div class="auth-input">
            <i class="bi bi-lock"></i
            ><input
              id="new-password"
              type="password"
              class="form-control"
              formControlName="password"
              placeholder="Mínimo 6 caracteres"
              autocomplete="new-password"
            />
          </div>
        </div>
        <div class="auth-field">
          <label for="password-confirmation">Confirmá la contraseña</label>
          <div class="auth-input">
            <i class="bi bi-lock-fill"></i
            ><input
              id="password-confirmation"
              type="password"
              class="form-control"
              formControlName="confirmPassword"
              placeholder="Repetí tu contraseña"
              autocomplete="new-password"
            />
          </div>
          <div class="auth-validation" *ngIf="form.touched && form.invalid">
            Las contraseñas deben coincidir e incluir letras, números y un
            carácter especial.
          </div>
        </div>
        <button class="auth-button" [disabled]="state === states.LOADING">
          <gd-inline-spinner
            *ngIf="state === states.LOADING"
            size="sm"
            tone="current"
          /><i *ngIf="state !== states.LOADING" class="bi bi-check-lg"></i
          >{{
            state === states.LOADING ? "Actualizando…" : "Actualizar contraseña"
          }}
        </button>
      </form>
      <div
        *ngIf="state === states.SUCCESS"
        class="auth-status auth-status--success"
      >
        <i class="bi bi-check-circle-fill"></i><span>{{ successMessage }}</span>
      </div>
      <div
        *ngIf="state === states.ERROR"
        class="auth-status auth-status--error"
      >
        <i class="bi bi-exclamation-circle-fill"></i
        ><span>{{ errorMessage }}</span>
      </div>
      <a routerLink="/login" class="auth-back"
        ><i class="bi bi-arrow-left"></i> Volver al inicio de sesión</a
      >
    </div>
  </section>
</main>
